import axios, { type AxiosInstance } from "axios";

let _token: string = "";
export class ServiceBase {
  axios: AxiosInstance;

  constructor() {
    const url =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_API_BASE_DEV_URL
        : process.env.REACT_APP_API_BASE_URL;

    this.axios = axios.create({
      baseURL: url,
    });

    this.axios.interceptors.request.use((config: any) => {
      const tokenSessionStorage = sessionStorage.getItem("Token");
      const token = _token;

      if (token !== "") {
        config.headers.Authorization = "Bearer " + token;
      }

      if (tokenSessionStorage !== null && token === "") {
        config.headers.Authorization = "Bearer " + tokenSessionStorage;
      }
      return config;
    });

    this.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          sessionStorage.clear();
          window.location.href = '/';
          alert("Sessão Expirada, Realize o login novamente");
        }
        return Promise.reject(error);
      }
    );
  }

  post(url: string, data: any | null) {
    return this.axios.post(url, data);
  }

  patch(url: string, data: any) {
    return this.axios.patch(url, data);
  }

  get(url: string) {
    return this.axios.get(url);
  }

  getWithParams(url: string, params: URLSearchParams) {
    return this.axios.get(url, { params });
  }

  put(url: string, data: any) {
    return this.axios.put(url, data);
  }
  delete(url: string) {
    return this.axios.delete(url);
  }

  setToken(token: string) {
    _token = token;
  }
}